import { Cities } from 'store/models/cities';

export const getCityName = (cities: Cities[], cityItem: string): string => {
  if (cities.length === 0) {
    return '';
  }
  return cities?.find((item) => item?.key === cityItem)?.value ?? '';
};
